import { Injectable, Injector, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(
    private router: Router,
    private cookieService: CookieService,
    @Optional() private injector?: Injector
  ) { }

  navigateTo(url: string, params: any = {}): void {
    this.router.navigate([url], { queryParams: params });
  }

  isLoggedIn(){
    let value = this.cookieService.get('isLoggedIn');
    return value && value == 'true' ? true : false;
  }
  getUserData(){
    let value = this.cookieService.get('userData');
    // console.log(value);
    return value ? JSON.parse(value) : null;
  }
  navigateWithId(url: string, id: string): void {
    this.router.navigate([url, id]);
  }

  logout(): void {
    // Stop inactivity tracking before logout (if service is available)
    // Note: We use a flag to avoid circular dependency
    // The inactivity service will handle stopping itself
    this.deleteAllCookies();
    this.router.navigate(['/login']);
  }
  deleteAllCookies(): void {
    // Get all cookie keys
    const allCookies: string[] = Object.keys(this.cookieService.getAll());

    // Iterate through each cookie key and delete it
    allCookies.forEach(cookieName => {
      this.cookieService.delete(cookieName);
      this.cookieService.delete(cookieName, '/'); // Include this to cover all paths
    });

    console.log('All cookies have been deleted');
  }
}
